import { CoachCompany } from '../../../lib/types/models/ol/coach-company/coach-company'
import { CoachCompanyInput } from '../../../lib/types/models/ol/coach-company/coach-company-input'
import { OlRateIdInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateCoachCompany = async (data: Partial<CoachCompanyInput> & OlRateIdInput) => {
  const { id, olId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.updateCoachCompany.url, { id, olId }))
    .patch<CoachCompany, Partial<CoachCompanyInput>>(rest)
}
